// extracted by mini-css-extract-plugin
module.exports = {"slides":"style_slides__gNDvW","iframe":"style_iframe__tsX0Z"};